// B1.4: move-only from client.ts.
import { ApiClientCore, buildQueryString } from './http/core';

export class BreaksApi extends ApiClientCore {
  async getBreaks(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/breaks${buildQueryString(params)}`);
  }
  // ─── Files ──────────────────────────────────────────────────────────────────
}
